import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router';
import { Container, Button, Grid, Paper } from '@material-ui/core';
import { LOGOUT } from 'ConstComponents';
import {
    UserOnbording as REGISTRTION,
} from 'Components/Api/OneClickAEPSAPI';
import { FetchDetailsForPincode as FETCH_DETAILS_FOR_PINCODE } from 'Components/Api/UsersApi';
import CircularProgress from '@material-ui/core/CircularProgress';
import HOCLoader from 'Components/Loader/HOCLoader';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { SelectProfile as USER_SELECT_BY_ID } from 'Components/Api/UsersApi';
import {
    PLEASE_PROVIDE_VALID,
} from 'Components/Helper/Messages';
import Box from '@material-ui/core/Box';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import SearchIcon from 'Components/SvgButtons/SearchIcon';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import { FailTransactionResponse } from 'Components/Alert/FailTransactionResponse';
import usePosition from 'Components/Posistion';
import { MaterialDatePickerField } from 'Components/Inputes/MaterialDatePickerField';

const CustomContainer = HOCLoader(Container);

export const OneClickUserOnbording = () => {
    const history = useHistory();
    const classes = commonStyle();
    const [loading, setLoading] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [status, setStatus] = useState('PROCESS');
    const [Message, setMessage] = useState('');
    const { latitude, longitude } = usePosition();
    const [isAlertErrorOpen, setIsAlertErrorOpen] = useState(false);
    const [formObject, setFormObject] = useState({
        AadhaarNo: '',
        MobileNo: '',
        PanNo: '',
        PinCode: '',
        Address: '',
        ShopName: '',
        City: '',
        AccountNumber: '',
        IFSCCode: '',
        Latitude: latitude,
        Longitude: longitude
    });

    useEffect(() => {
        //setLoading(true);
        SelectByID();
    }, [latitude], [longitude]);

    const SelectByID = async () => {
        setLoading(true);

        const { isAuthorized, status, data } = await USER_SELECT_BY_ID();
        setLoading(false);

        if (!isAuthorized) LOGOUT();

        if (!status) return;

        var d = JSON.parse(data);

        setFormObject({
            ...formObject,
            PanNo: d.PANNo,
            AadhaarNo: d.AadharNo,
            MobileNo: d.MobileNumber,
            City: d.City,
            Address: d.Address,
            PinCode: d.PinCode
        });
    };
    const FormValidationSchema = Yup.object({
        AccountNumber: Yup.string().required(
            PLEASE_PROVIDE_VALID + 'AccountNumber'
        ),
        IFSCCode: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'IFSCCode'),
        PanNo: Yup.string().required(PLEASE_PROVIDE_VALID + 'PanNo'),
        AadhaarNo: Yup.string().required(PLEASE_PROVIDE_VALID + 'AadhaarNo'),
        MobileNo: Yup.string().required(PLEASE_PROVIDE_VALID + 'MobileNo'),

        City: Yup.string()
            .trim()
            .required(PLEASE_PROVIDE_VALID + 'City'),
        PinCode: Yup.string()
            .trim()
            .required(PLEASE_PROVIDE_VALID + 'PinCode'),
    });

    const submitHandle = async (values, { resetForm }) => {
        setIsError(false);
        setLoading(true);
        var inputObj = {
            AadhaarNo: values.AadhaarNo,
            PanNo: values.PanNo,
            MobileNo: values.MobileNo,
            PinCode: values.PinCode,
            Address: values.Address,
            City: values.City,
            ShopName: values.ShopName,
            AccountNumber: values.AccountNumber,
            DateOfBirth: values.DateOfBirth,
            IFSCCode: values.IFSCCode,
            Latitude: latitude,
            Longitude: longitude
        };
        var requestObj = JSON.stringify(inputObj);
        var response = await REGISTRTION(requestObj);
        setLoading(false);

        if (!response.isAuthorized) LOGOUT();

        setIsError(true);
        setSeverity('success');
        if (!response.status) {
            var data = JSON.parse(response.data);
            setSeverity('error');
            setResponseMessage(data.Message);

            setStatus('FAILURE');
            setMessage(data.Message);
            setIsAlertErrorOpen(true);
            return;
        }

        var data = JSON.parse(response.data); 
        setResponseMessage(data.Message);
        if (data.Status === 'FAILURE') {
            setSeverity('error');
            setIsError(true);

            setStatus('FAILURE');
            setMessage(data.Message);
            setIsAlertErrorOpen(true);
            if (data.Message === 'User already onboarded') {
                history.push('/OCAuthentication');
                return;
            }
        }
        history.push('/OCSendOTP', {
            latitude: latitude,
            longitude: longitude,
            AadhaarNo: data.AadhaarNo,
            MobileNo: data.MobileNo,
            PanNo: data.PanNo
        });
    };

    const FetchDetails = async (values, setFieldValue) => {
        var request = {
            PinCode: values.PinCode
        };
        var requestObj = JSON.stringify(request);

        setLoading(true);
        setIsError(false);

        var response = await FETCH_DETAILS_FOR_PINCODE(requestObj);

        if (!response.isAuthorized) LOGOUT();

        setLoading(false);
        setIsError(true);
        setSeverity('success');

        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);
            setStatus('FAILURE');
            setMessage(response.data);
            setIsAlertErrorOpen(true);
            return;
        }

        var data = JSON.parse(response.data);

        setFieldValue('Address', data.CityName);
        setFieldValue('City', data.District);
    };

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                enableReinitialize={true}
                initialValues={formObject}
                validationSchema={FormValidationSchema}
                onSubmit={submitHandle}
                resetForm={formObject}
                render={({ values, errors, setFieldValue }) => {
                    return (
                        <Grid
                            item
                            container
                            margin="normal"
                            xs={12}
                            md={12}
                            sm={12}
                            lg={12}
                            spacing={1}
                        >
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <Form>
                                    <h2 className={classes.PaperHead_h2}>
                                        User Onborad :: Latitude: {latitude}, Longitude:{longitude}
                                    </h2>
                                    <Grid item xs={12}>
                                        <Paper className={classes.PaperStyle}>
                                            <Grid container spacing={2}>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={3}
                                                    lg={3}
                                                >
                                                    <MaterialTextField
                                                        label="Mobile No"
                                                        name="MobileNo"
                                                        type="text"
                                                        length={10}
                                                        placeholder="Mobile Number"
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={3}
                                                    lg={3}
                                                >
                                                    <MaterialTextField
                                                        label="Pan Card"
                                                        name="PanNo"
                                                        type="text"
                                                        length={10}
                                                        placeholder="Pan Number"
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={3}
                                                    lg={3}
                                                >
                                                    <MaterialTextField
                                                        label="Aadhaar No"
                                                        name="AadhaarNo"
                                                        type="text"
                                                        length={12}
                                                        placeholder="Aadhaar Number"
                                                    />
                                                </Grid>

                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={3}
                                                    lg={3}
                                                >
                                                    <MaterialTextField
                                                        label="City"
                                                        name="City"
                                                        type="text"
                                                        icon="shop"
                                                        title="City"
                                                    />
                                                </Grid>

                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={3}
                                                    lg={3}
                                                >
                                                    <MaterialTextField
                                                        label="Shop Name"
                                                        name="ShopName"
                                                        type="text"
                                                        icon="ShopName"
                                                        title="Shop Name"
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={3}
                                                    lg={3}
                                                >
                                                    <MaterialNumberField
                                                        label="Pin code"
                                                        name="PinCode"
                                                        type="text"
                                                        length={6}
                                                        title="Pin code"
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={6}
                                                    lg={6}
                                                >
                                                    <MaterialTextField
                                                        label="Address"
                                                        name="Address"
                                                        type="text"
                                                        title="Address"
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={3}>
                                                    <MaterialDatePickerField
                                                        name="DateOfBirth"
                                                        label="Date Of Birth"
                                                        maxDate={new Date()}
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={3}
                                                    lg={3}
                                                >
                                                    <MaterialNumberField
                                                        label="Bank Account Number"
                                                        name="AccountNumber"
                                                        type="text"
                                                        length={18}
                                                        title="Bank Account Number"
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={3}
                                                    lg={3}
                                                >
                                                    <MaterialTextField
                                                        label="IFSC Code"
                                                        name="IFSCCode"
                                                        type="text"
                                                        length={12}
                                                        title="IFSC Code"
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={1}
                                                    lg={1}
                                                >
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        endIcon={<SearchIcon />}
                                                        className={
                                                            classes.CustomPrimaryButtonStyle
                                                        }
                                                        onClick={() => {
                                                            FetchDetails(
                                                                values,
                                                                setFieldValue
                                                            );
                                                        }}
                                                        style={{
                                                            marginLeft: '10px'
                                                        }}
                                                    ></Button>
                                                </Grid>
                                            </Grid>
                                        </Paper>
                                    </Grid>

                                    <Grid className={classes.footerGrid}>
                                        <Box className={classes.flexReverse}>
                                            <div
                                                className={
                                                    classes.SubmitWrapper
                                                }
                                            >
                                                <Button
                                                    type="submit"
                                                    title="Register"
                                                    className={
                                                        classes.CustomPrimaryButtonStyle
                                                    }
                                                    disabled={loading}
                                                >
                                                    Register
                                                </Button>
                                                {loading && (
                                                    <CircularProgress
                                                        size={24}
                                                        className={
                                                            classes.buttonProgress
                                                        }
                                                    />
                                                )}
                                            </div>
                                            <Button
                                                type="reset"
                                                title="Reset"
                                                className={
                                                    classes.CustomDangerButtonStyle
                                                }
                                            >
                                                Reset
                                            </Button>
                                        </Box>
                                    </Grid>
                                </Form>
                            </Grid>
                        </Grid>
                    );
                }}
            />

            {isAlertErrorOpen && (
                <FailTransactionResponse
                    isOpen={isAlertErrorOpen}
                    title={status}
                    Message={Message}
                    OkButtonClick={(request) => {
                        setIsAlertErrorOpen(false);
                    }}
                />
            )}
        </CustomContainer>
    );
};
